var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLedOffSecondary = function SvgIconLedOffSecondary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF008E",
    d: "M1.308 14.75v-1.5H5v1.5zM11.25 7V2.308h1.5V7zm6.208 2.567-1.045-1.054L19.046 5.9l1.06 1.054zM19 14.75v-1.5h3.692v1.5zm.804 7.192L15.36 17.5H7.25V15h5.611L2.058 4.196l1.069-1.07 17.746 17.747z"
  })));
};
export default SvgIconLedOffSecondary;